// In-team chat panel. The protocol already supports `chat` messages — this
// just surfaces them. Filters log entries by `kind: "chat"` for the team.

import { useEffect, useRef, useState } from "react";
import type { LogEntry } from "../types";

interface Props {
  log: LogEntry[];
  myTeamId?: string;
  onSend: (text: string) => void;
}

export function Chat({ log, myTeamId, onSend }: Props) {
  const [text, setText] = useState("");
  const scrollRef = useRef<HTMLDivElement>(null);
  const messages = log.filter((e) => e.kind === "chat" && e.teamId === myTeamId);

  useEffect(() => {
    if (scrollRef.current) scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
  }, [messages.length]);

  return (
    <div className="chat">
      <div className="chat-list" ref={scrollRef}>
        {messages.length === 0 && (
          <div className="chat-empty">
            Talk to your team. Real IR is talking.
          </div>
        )}
        {messages.map((m, i) => (
          <div key={`${m.at}-${i}`} className="chat-row">
            <span className="chat-handle">{m.playerId ? m.playerId.split("-")[1] : "?"}</span>
            <span className="chat-text">{m.text}</span>
          </div>
        ))}
      </div>
      <form
        className="chat-input"
        onSubmit={(e) => {
          e.preventDefault();
          const t = text.trim();
          if (!t) return;
          onSend(t);
          setText("");
        }}
      >
        <input
          type="text"
          value={text}
          onChange={(e) => setText(e.target.value)}
          placeholder="message your team…"
          maxLength={500}
        />
        <button type="submit" className="primary">Send</button>
      </form>
    </div>
  );
}
